<template>
  <div
    v-if="content"
    class="columns m-auto"
    :style="{ 'max-width': content.containWidth ? '1280px' : '100%' }"
  >
    <h2 v-if="content.title" class="title" v-html="content.title"></h2>
    <ul>
      <li :key="item.uuid" v-for="(item, i) in content.items">
        <component :is="item.component" :content="item" :count="i"></component>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  }
};
</script>

<style lang="scss">
.columns {
  h2 {
    text-align: center;
  }
  > ul {
    display: flex;
    justify-content: center;
    margin: 0 1em;
    gap: 30px;
    > li {
      flex: 1;
    }
  }
  .bloc-image,
  .bloc-image img {
    max-width: none !important;
  }
}
@media screen and (max-width: 1000px) {
  .columns {
    > ul {
      flex-direction: column;
    }
  }
}
</style>
